import { render, staticRenderFns } from "./TransportationDocumentHeaderComponent.vue?vue&type=template&id=33172114&"
import script from "./TransportationDocumentHeaderComponent.vue?vue&type=script&lang=js&"
export * from "./TransportationDocumentHeaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports